import {baseApi} from '../rest'
import qs from 'query-string'
import _ from 'lodash'
import {FilterOptions} from '../tasks/effects'
import {Alarm, AlarmResolveFilters} from './state'

export const alarmsApi = {
  ...baseApi,
  async resolveAllTaskAlarms(siteId: string, payload: {resolution: string; resolvedBy?: string}): Promise<any> {
    const request = await this.doRequest({
      path: '/v1/alarms/resolve-all/tasks',
      site: siteId,
      payload
    })
    const response = await request.put()
    return response.data as any
  },
  async resolveAllApplianceAlarms(siteId: string, payload: {resolution: string; resolvedBy?: string}): Promise<any> {
    const request = await this.doRequest({
      path: '/v1/alarms/resolve-all/appliances',
      site: siteId,
      payload
    })
    const response = await request.put()
    return response.data as any
  },
  async resolveFilteredTaskAlarms(
    siteId: string,
    payload: {resolution: string; resolvedBy?: string; filters: AlarmResolveFilters}
  ): Promise<any> {
    const request = await this.doRequest({
      path: '/v1/alarms/resolve-filtered/tasks',
      site: siteId,
      payload
    })
    const response = await request.put()
    return response.data as any
  },
  async resolveFilteredApplianceAlarms(
    siteId: string,
    payload: {resolution: string; resolvedBy?: string; filters: AlarmResolveFilters}
  ): Promise<any> {
    const request = await this.doRequest({
      path: '/v1/alarms/resolve-filtered/appliances',
      site: siteId,
      payload
    })
    const response = await request.put()
    return response.data as any
  },
  async attachAlarmAsset(alarmId: string, siteId: string, assetId: string): Promise<Alarm> {
    const request = await this.doRequest({
      path: `/v1/alarms/${alarmId}/assets`,
      site: siteId,
      payload: {assetId}
    })
    const response = await request.post()
    return (response as unknown) as Alarm
  },
  async detachAlarmAsset(alarmId: string, siteId: string, assetId: string): Promise<Alarm> {
    const request = await this.doRequest({
      path: `/v1/alarms/${alarmId}/assets/${assetId}`,
      site: siteId
    })
    const response = await request.delete()
    return (response as unknown) as Alarm
  },
  async getAlarm(alarmId: string, siteId: string): Promise<Alarm> {
    const request = await this.doRequest({
      path: `/v1/alarms/${alarmId}`,
      site: siteId
    })
    const response = await request.get()
    return (response as unknown) as Alarm
  },
  async deleteAlarm(alarmId: string) {
    const request = await this.doRequest({
      path: `/v1/alarms/${alarmId}`
    })
    const response = await request.delete()
    return response
  },
  async updateAlarm(alarmId: string, siteId: string, payload: any): Promise<Alarm> {
    const request = await this.doRequest({
      path: `/v1/alarms/${alarmId}`,
      site: siteId,
      payload: payload
    })
    const response = await request.put()
    return response.data as Alarm
  },
  async getMoreAlarmsForSite(siteId: string, type: string, options?: FilterOptions): Promise<any> {
    const qstring = options ? qs.stringify({...options, type}, {arrayFormat: 'comma'}) : undefined
    const path = `/v2/alarms/site/${siteId}/paging/loadMore?${qstring}`
    const request = await this.doRequest({path})
    const response = await request.get()
    return (response as unknown) as any
  },
  async getAlarmsForSiteWithPagination(siteId: string, options?: FilterOptions): Promise<any> {
    const qstring = options ? qs.stringify(options, {arrayFormat: 'comma'}) : undefined
    const path = `/v2/alarms/site/${siteId}/paging?${qstring}`
    const request = await this.doRequest({path})
    const response = await request.get()
    return (response as unknown) as any
  },
  async saveCommentForAlarm(alarmId: string, siteId: string, payload: any) {
    const request = await this.doRequest({
      path: `/v1/alarms/saveComment/${alarmId}`,
      site: siteId,
      payload: payload
    })
    const response = await request.put()
    return response.data
  }
}
